import * as R from "ramda";
import React from "react";
import FlexView from "react-flexview";
import { connect } from "react-redux";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import * as ErrorAction from "../../../../../Redux/ErrorRedux";
import Api from "../../../../../Services/Api";
import { fetchDataAsync } from "../../../../../Services/Utils";
import SimpleCheckBox from "../../../../../modules/SimpleCheckBox";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import Container from "../../../../../modules/commons/Container";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import { HttpStatus } from "../../../../common/Constants";
import { mapToObjectDDL } from "../../../../common/mapper";
import LaporanServiceHarian from "./laporanServiceHarian/laporanServiceHarian";
import LaporanMTD from "./laporanMTD/laporanMTD";
import LaporanServiceYTD from "./laporanServiceYTD/laporanServiceYTD";
import LaporanUnitL3Y from "./laporanUnitL3Y/laporanUnitL3Y";
import SimpleLoadingOverlay from "../../../../../modules/popup/SimpleLoadingOverlay";

class DashboardLaporanHarianUnitByCabang extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      isAllSelected: true,
      isSpecificSelected: false,
      dataCabang: [],
      kodeCabang: [],
      search: null,
      doSearch: false,
    };
  }

  componentDidMount = async () => {
    this.fetchDataCabang();
  };

  fetchDataCabang = async () => {
    this.handleTriggerLoading();
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").findAllMasterCabang,
      setError: this.props.setError,
      menuName:
        "Dashboard Level Kepala Cabang Keatas - Laporan Harian By Cabang",
      args: null,
    });

    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      const filteredData = res.data.data.filter((item) =>
        this.props.menuAccess
          .map((data) => data.idRefObj)
          .includes(item.kodeCabang),
      );

      if (filteredData.length !== 0) {
        this.setState((prevValue) => ({
          ...prevValue,
          dataCabang: filteredData,
          search: filteredData?.map((item) => item.kodeCabang),
        }));
      }
    }
    this.handleTriggerLoading();
  };

  handleTriggerLoading = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      loading: !prevValue.loading,
    }));
  };

  handleSelectCabang = (e, type) => {
    const isChecked = e.target.checked;

    if (type === "ALL") {
      this.setState((prevValue) => ({
        ...prevValue,
        isAllSelected: isChecked,
        isSpecificSelected: false,
        kodeCabang: [],
      }));
    }

    if (type === "SPECIFIC") {
      this.setState((prevValue) => ({
        ...prevValue,
        isSpecificSelected: isChecked,
        isAllSelected: false,
        kodeCabang: [],
      }));
    }
  };

  handleSearch = () => {
    const { dataCabang, kodeCabang, isAllSelected, isSpecificSelected } =
      this.state;

    let kodeCabangList = [];

    if (isAllSelected) {
      kodeCabangList = dataCabang.map((item) => item.kodeCabang);
    }

    if (isSpecificSelected && kodeCabang?.length > 0) {
      kodeCabangList = kodeCabang.map((item) => item.value);
    }

    if (kodeCabangList?.length === 0) {
      return;
    }

    this.setState((prev) => ({
      ...prev,
      search: kodeCabangList,
      doSearch: true,
    }));
  };

  handleChangeCabang = (value) => {
    this.setState((prevValue) => ({ ...prevValue, kodeCabang: value }));
  };

  handleSuccessFetchData = (callback) => {
    this.setState((prev) => ({
      ...prev,
      doSearch: false,
    }));
  };

  render() {
    const {
      search,
      loading,
      isAllSelected,
      isSpecificSelected,
      dataCabang,
      kodeCabang,
      doSearch
    } = this.state;
    return (
      <React.Fragment>
        <Container>
          <FlexView style={{ gap: "20px", alignItems: "center" }}>
            <SimpleCheckBox
              id="reportAllCabang"
              key="reportAllCabang"
              name="reportAllCabang"
              label="ALL CABANG"
              checked={isAllSelected}
              onChange={(e) => this.handleSelectCabang(e, "ALL")}
            />
            <SimpleCheckBox
              id="reportSpecificCabang"
              key="reportSpecificCabang"
              name="reportSpecificCabang"
              label="SPESIFIK CABANG"
              checked={isSpecificSelected}
              onChange={(e) => this.handleSelectCabang(e, "SPECIFIC")}
            />
            <SimpleDDL
              id="select_options_kode_cabang"
              box="multiselect"
              name="kodeCabang"
              containerclassname="width width-500px margin-top-15px"
              placeholder="Nama Cabang"
              readOnly={!isSpecificSelected}
              options={dataCabang.map((item) =>
                mapToObjectDDL(item.namaDealer, item.kodeCabang),
              )}
              value={kodeCabang}
              onChange={(value) => this.handleChangeCabang(value)}
            />
            <SimpleButton onClick={this.handleSearch}>Cari</SimpleButton>
          </FlexView>
          <Tabs>
            <TabList>
              <Tab>Laporan Service Harian</Tab>
              <Tab>Laporan Service MTD</Tab>
              <Tab>Laporan Unit Entri MTD by Cabang</Tab>
              <Tab>Laporan Unit Servis Non KPB MTD by Cabang</Tab>
              <Tab>Laporan Servis YTD</Tab>
              <Tab>Laporan Unit Entri 3 Tahun Terakhir</Tab>
              <Tab>Laporan Unit Servis Non KPB 3 Tahun Terakhir</Tab>
            </TabList>
            <TabPanel>
              <LaporanServiceHarian
                {...this.props}
                onTriggerLoading={this.handleTriggerLoading}
                onSuccess={this.handleSuccessFetchData}
                doSearch={doSearch}
                kodeCabang={search}
              />
            </TabPanel>
            <TabPanel>
              <LaporanMTD
                {...this.props}
                onTriggerLoading={this.handleTriggerLoading}
                onSuccess={this.handleSuccessFetchData}
                doSearch={doSearch}
                kodeCabang={search}
                type="service"
              />
            </TabPanel>
            <TabPanel>
              <LaporanMTD
                {...this.props}
                onTriggerLoading={this.handleTriggerLoading}
                onSuccess={this.handleSuccessFetchData}
                doSearch={doSearch}
                kodeCabang={search}
                type="unit_entri"
              />
            </TabPanel>
            <TabPanel>
              <LaporanMTD
                {...this.props}
                onTriggerLoading={this.handleTriggerLoading}
                onSuccess={this.handleSuccessFetchData}
                doSearch={doSearch}
                kodeCabang={search}
                type="service_non_kpb"
              />
            </TabPanel>
            <TabPanel>
              <LaporanServiceYTD 
                {...this.props}
                onTriggerLoading={this.handleTriggerLoading}
                onSuccess={this.handleSuccessFetchData}
                doSearch={doSearch}
                kodeCabang={search}
              />
            </TabPanel>
            <TabPanel>
              <LaporanUnitL3Y
                {...this.props}
                onTriggerLoading={this.handleTriggerLoading}
                onSuccess={this.handleSuccessFetchData}
                doSearch={doSearch}
                kodeCabang={search}
                type="unit_entri"
              />
            </TabPanel>
            <TabPanel>
              <LaporanUnitL3Y
                {...this.props}
                onTriggerLoading={this.handleTriggerLoading}
                onSuccess={this.handleSuccessFetchData}
                doSearch={doSearch}
                kodeCabang={search}
                type="service"
              />
            </TabPanel>
          </Tabs>
        </Container>
        {loading && <SimpleLoadingOverlay active={loading} />}
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setError: (payload) => dispatch(ErrorAction.setError(payload)),
  };
};

export default connect(
  null,
  mapDispatchToProps,
)(DashboardLaporanHarianUnitByCabang);
